import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const OCCUPATION_DELETE_RESOURCE = "occupation" as const;
export const OCCUPATION_DELETE_API_PATH = `/v1/${OCCUPATION_DELETE_RESOURCE}/{uuid}` as const;

export type OccupationDeleteResponse =
  paths[typeof OCCUPATION_DELETE_API_PATH]["delete"]["responses"][200]["content"]["application/json"];

export const useOccupationDeleteMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<OccupationDeleteResponse, Error, { uuid: string; force?: boolean }>({
    mutationFn: async ({ uuid, force }) => {
      const response = await alphartisApiAxios.delete<OccupationDeleteResponse>(
        `/v1/${OCCUPATION_DELETE_RESOURCE}/${uuid}`,
        { params: { force } },
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [OCCUPATION_DELETE_RESOURCE],
      });
    },
  });
};
